/*
 * @Author: 吴文洁
 * @Date: 2020-12-31 11:50:25
 * @LastEditors: renmanyi
 * @LastEditTime: 2022-08-20 13:39:50
 * @Description:
 * @Copyright: 杭州杰竞科技有限公司 版权所有
 */

export function validateImageType(type: string): boolean {
  const imgTypeList = ['image/png', 'image/jpg', 'image/jpeg'];

  if (imgTypeList.includes(type)) {
    return true;
  }

  return false;
}
export function validateVideoType(type: string): boolean {
  const imgTypeList = ['video/mp4'];

  if (imgTypeList.includes(type)) {
    return true;
  }

  return false;
}
/**
 * 生成指定长度的随机字符串
 * @param len
 * @returns {string}
 */
export function random_string(len: number): string {
  len = len || 32;
  const chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
  const maxPos = chars.length;
  let pwd = '';
  for (let i = 0; i < len; i++) {
    pwd += chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return pwd;
}
